import { of, Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { isNullOrUndefined } from '@app/util/util';
import { Place } from '@app/entities/place';
import { IS_BROWSER } from '@app/modules/core/tokens/app.tokens';

declare const external_file_cities;

@Injectable({
  providedIn: 'root'
})
export class PlacesService {

  private places: Place[] = [];

  constructor(private http: HttpClient,
    @Inject(IS_BROWSER) public isBrowser: boolean) {
    if (this.isBrowser) {
      this.places = !isNullOrUndefined(external_file_cities) ? external_file_cities.map(item => {
        const splitCity = item.split(',');
        let splitCountry = splitCity[1].split('(');
        let code = splitCountry[1] ? splitCountry[1].slice(0, splitCountry[1].length - 1) : '';
        let country = splitCountry[0].replace(/^\s+|\s+$/g, '');
        if (splitCity.length > 2) {
          splitCountry = splitCity[2].split('(');
          code = splitCountry[1] ? splitCountry[1].slice(0, splitCountry[1].length - 1) : '';
          country = splitCountry[0].replace(/^\s+|\s+$/g, '');
        }
        return {
          id: code,
          country: country,
          city: splitCity[0],
          cityCode: code,
          name: `${splitCity[0]}, ${country}`,
          statecode: `${splitCity.length > 2 ? splitCity[1].replace(/^\s+|\s+$/g, '') : ''}`
        };
      }) : [];
    }
  }

  public fetchPlaces(): Observable<Place[]> {
    return of(this.places.filter(place => place.id !== ''));
  }
}
